export const SET_OPEN_MENU = "set_open_menu";
export const SET_IMAGE_GROUP = "set_image_group";
export const SET_IMAGE_HEADER = "set_image_header";
export const SET_DATA_FIELD = "set_data_field";
export const SET_HEADER_TITLE = "set_header_title";
export const SET_MODE_HISTORY = "set_mode_history";
